<template>
  <div>
    <div v-if="missingProperty" class="property-required">
      <section class="property-required-content">
        <div class="property-required-mark" aria-hidden="true"></div>
        <div class="property-required-title">Property is required</div>
        <div class="property-required-message">
          Please provide a property to view the public chores list.
        </div>
      </section>
    </div>
    <MyChoresScreenMobile v-else-if="smallDevice" />
    <div v-else-if="isLoading" class="chores-body">
      <chores-skeleton />
    </div>
    <div class="chores-body" v-else>
      <div class="chores-top-container">
        <div class="chores-title">{{ property }} Chores</div>
        <div class="chores-menu-container"></div>
      </div>
      <div class="chores-bottom-container">
        <a-skeleton avatar :paragraph="{ rows: 4 }" />

        <ChoreCell
          v-for="chore of this.filteredChores"
          :key="chore.uuid"
          :chore="chore"
          :readOnly="true"
          :returnHousemates="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChoreCell from '@/components/tasks/ChoreCell.vue'
import calls from '@/api/calls'
import MyChoresScreenMobile from '../../components/mobile/MobileCalendar.vue'
import ChoresSkeleton from '@/components/shared/ChoresSkeleton.vue'
import { filterChoresWithUpcomingAssignments } from '@/functions/choreDateFilter'
export default {
  name: 'PublicChoresScreen',
  components: {
    ChoreCell,
    MyChoresScreenMobile,
    ChoresSkeleton
  },
  data() {
    return {
      chores: [],
      propChores: [],
      properties: [],
      selTask: null,
      selPropperty: {},
      selAssignment: null,
      showMenu: false,
      showDeleteMenu: false,
      showEditAssignmentMenu: false,
      showAssignmentMenu: false,
      allHousemates: [],
      propertiesFilterSelected: false,
      choresFilterSelected: false,
      mouseCoordsProperties: null,
      mouseCoordsChores: null,
      selProperties: [],
      selChores: [],
      selChore: null, //the chore from the chore card that you are assigning
      referencedProperty: null, //the propertie from which this chore belongs to ^
      choresListKey: 0,
      property: '',
      smallDevice: false,
      isLoading: false
    }
  },
  computed: {
    filteredChores() {
      return this.chores
    },
    propertyQuery() {
      const property = this.$route.query.property
      if (typeof property !== 'string') return ''
      return property.trim()
    },
    missingProperty() {
      return !this.propertyQuery
    }
  },
  methods: {
    async loadData() {
      const propertyName = this.propertyQuery
      if (!propertyName) return

      {
        const { data, message } = await calls.GET(
          'chores/from/property-name-and-return-housemate',
          propertyName
        )
        this.property = this.toSentenceCase(propertyName)
        for (const index in data) {
          data[index].propertyInternalName = this.property
        }
        this.chores = filterChoresWithUpcomingAssignments(data)
      }
    },
    onResize() {
      this.menuOpen = false
      this.width = window.innerWidth

      if (this.width > 768) {
        this.smallDevice = false
        this.menuOpen = true
      } else {
        this.smallDevice = true
      }
    },
    toSentenceCase(text) {
      text = text.replace(/([A-Z])/g, ' $1')
      const result = text.charAt(0).toUpperCase() + text.slice(1)
      return result.trim()
    }
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  async mounted() {
    this.onResize()
    if (this.missingProperty) return

    this.isLoading = true
    await this.loadData()
    document.title = `Rentalios | ${this.property} Chores`
    this.isLoading = false
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.chores-body {
  padding: 24px 24px 0 24px;
  background-color: #f5f6f8;
}

.chores-top-container {
  width: 100%;
  height: 40px;
  margin-left: 10px; /* to match up with the cards */
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.chores-bottom-container {
  padding: 0;
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: auto;
}

.chores-title {
  font-family: Montserrat;
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 1px;
  text-align: left;
  color: #000000;
}

.chores-menu-container {
  width: 650px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.empty-chores-screen {
  width: 100%;
  padding-top: 10%;
  height: 90%;
}
.empty-chores-screen img {
  width: 50%;
  height: 50%;
}

.empty-chores-screen div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
}

.empty-chores-screen button {
  border: none;
  background: #66b015;
  border-radius: 4px;
  width: 192px;
  height: 40px;
  color: white;
  font-family: Montserrat;
  font-size: 16px;
}

.no-result {
  font-weight: 900 !important;
}

.property-required {
  min-height: calc(100vh - 80px);
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 64px 32px 0;
}

.property-required-content {
  max-width: 440px;
  text-align: center;
}

.property-required-mark {
  width: 40px;
  height: 3px;
  margin: 0 auto 20px;
  border-radius: 2px;
  background-color: #66b015;
}

.property-required-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0.2px;
  color: #1c1c1c;
}

.property-required-message {
  margin-top: 12px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: #6b7280;
}

.task-calendar-filter-container {
  position: absolute;
}

@media only screen and (max-width: 768px) {
  .chores-body {
    padding: 0;
    background-color: #f5f6f8;
    height: 1000px;
  }
}
</style>
